import { Stack, Box } from "@mui/system";
import React from "react";
import { FaFacebook, FaInstagram, FaTwitter, FaYoutube } from "react-icons/fa";

const SocialMediaSection = () => {
  return (
    <Stack sx={{marginBottom: "80px"}}>
      <Box sx={{display: "flex", justifyContent: "space-between", alignItems: "center", width: {xs: "45%", lg: "30%"}, margin: "10px auto"}}>
        <FaFacebook size={22} color="#3b5998" cursor={"pointer"}/>
        <FaInstagram  size={22} color="#802145" cursor={"pointer"}/>
        <FaTwitter  size={22} color="#0066ff" cursor={"pointer"}/>
        <FaYoutube  size={22} color="#c4302b" cursor={"pointer"}/>
      </Box>
    </Stack>
  );
};

export default SocialMediaSection;
